import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

export const getStringCustomField = (
  custom: Record<string, unknown>,
  key: string
): O.Option<string> =>
  pipe(
    O.fromNullable(custom[key]),
    O.chain(s => (typeof s === 'string' ? O.some(s) : O.none))
  )
